import { Injectable } from '@angular/core';
import Shepherd from 'shepherd.js';

export interface TourStep {
  id: string;
  title: string;
  text: string;
  attachTo?: { element: string; on: string };
  beforeShowPromise?: () => Promise<void>;
}

@Injectable({ providedIn: 'root' })
export class TourService {
  private tour: InstanceType<typeof Shepherd.Tour> | null = null;

  start(tourKey: string, steps: TourStep[], autoOnly = false, onFinish?: () => void): void {
    if (autoOnly && localStorage.getItem(tourKey) === 'done') {
      return;
    }

    this.cancel();

    this.tour = new Shepherd.Tour({
      useModalOverlay: true,
      defaultStepOptions: {
        classes: 'deebr-tour-step',
        scrollTo: true,
        cancelIcon: { enabled: true },
      },
    });

    steps.forEach((step, i) => {
      const isFirst = i === 0;
      const isLast = i === steps.length - 1;

      const buttons: Array<{ text: string; action: () => void; classes?: string }> = [];
      if (!isFirst) {
        buttons.push({ text: 'Précédent', action: () => this.tour!.back(), classes: 'shepherd-button-secondary' });
      }
      if (isLast) {
        buttons.push({ text: 'Terminer', action: () => this.tour!.complete() });
      } else {
        buttons.push({ text: 'Suivant', action: () => this.tour!.next() });
      }

      this.tour!.addStep({
        id: step.id,
        title: step.title,
        text: step.text,
        attachTo: step.attachTo ? { element: step.attachTo.element, on: step.attachTo.on as any } : undefined,
        beforeShowPromise: step.beforeShowPromise,
        buttons,
      });
    });

    this.tour.on('complete', () => {
      localStorage.setItem(tourKey, 'done');
      onFinish?.();
    });

    this.tour.on('cancel', () => {
      localStorage.setItem(tourKey, 'done');
      onFinish?.();
    });

    this.tour.start();
  }

  cancel(): void {
    if (this.tour) {
      this.tour.cancel();
      this.tour = null;
    }
  }

  reset(tourKey: string): void {
    localStorage.removeItem(tourKey);
  }

  isCompleted(tourKey: string): boolean {
    return localStorage.getItem(tourKey) === 'done';
  }
}
